import { Box, Typography } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

export const DropZone = styled('div')<{ $isDragOver: boolean; $disabled: boolean }>(
    ({ theme, $isDragOver, $disabled }) => ({
        border: `2px dashed ${$isDragOver ? theme.palette.primary.main : '#c0c0c0'}`,
        borderRadius: 12,
        padding: '2rem 1.5rem',
        textAlign: 'center',
        cursor: $disabled ? 'not-allowed' : 'pointer',
        background: $isDragOver ? '#e8f5e920' : '#fafafa',
        transition: 'border-color 0.2s, background 0.2s',
        opacity: $disabled ? 0.5 : 1,
        '&:hover': $disabled ? {} : {
            borderColor: theme.palette.primary.main,
            background: '#f0f7ff',
        },
    }),
);

export const UploadingRow = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.75rem',
    paddingBlock: '0.5rem',
});

export const UploadIcon = styled(CloudUpload, {
    shouldForwardProp: prop => prop !== '$disabled',
})<{ $disabled: boolean }>(({ theme, $disabled }) => ({
    fontSize: 40,
    color: $disabled ? '#ccc' : theme.palette.secondary.main,
    marginBottom: '0.25rem',
}));

export const Caption = styled(Typography)({
    marginTop: '0.25rem',
});

export const DesktopOnlyLabel = styled('span')(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));

export const MobileOnlyLabel = styled('span')(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.down('sm')]: {
        display: 'inline',
    },
}));
